"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTypes = void 0;
var PolicyTypes;
(function (PolicyTypes) {
    PolicyTypes["BOAT"] = "BOAT";
    PolicyTypes["COMMERCIAL_AUTO"] = "COMMERCIAL_AUTO";
    PolicyTypes["CONDO"] = "CONDO";
    PolicyTypes["DWELLING_FIRE"] = "DWELLING_FIRE";
    PolicyTypes["FLOOD"] = "FLOOD";
    PolicyTypes["HOMEOWNERS"] = "HOMEOWNERS";
    PolicyTypes["IDENTITY_THEFT"] = "IDENTITY_THEFT";
    PolicyTypes["LANDLORD"] = "LANDLORD";
    PolicyTypes["LIFE"] = "LIFE";
    PolicyTypes["MOBILE_HOME"] = "MOBILE_HOME";
    PolicyTypes["MOTORCYCLE"] = "MOTORCYCLE";
    PolicyTypes["OFFROAD_VEHICLE"] = "OFFROAD_VEHICLE";
    PolicyTypes["PERSONAL_AUTO"] = "PERSONAL_AUTO";
    PolicyTypes["PET"] = "PET";
    PolicyTypes["RENTERS"] = "RENTERS";
    PolicyTypes["RV"] = "RV";
    PolicyTypes["UMBRELLA"] = "UMBRELLA";
    PolicyTypes["VALUABLES"] = "VALUABLES";
})(PolicyTypes = exports.PolicyTypes || (exports.PolicyTypes = {}));
